module.exports = __webpack_public_path__ + "static/media/comment.be608031.svg";